export enum MembershipStatusCode {
    PROS = 'PROS',
    PEND = 'PEND',
    PRI = 'PRI',
    ERSC = 'ERSC',
    CANC = 'CANC',
    NONR = 'NONR',
    IMPR = 'IMPR',
    FUTR = 'FUTR',
    VALD = 'VALD',
    EXPD = 'EXPD'
  }
  
  export const MembershipStatus = {
    [MembershipStatusCode.PROS]: 'Prospect',
    [MembershipStatusCode.PEND]: 'Pending',
    [MembershipStatusCode.PRI]: 'Prior',
    [MembershipStatusCode.ERSC]: 'ERS cancel',
    [MembershipStatusCode.CANC]: 'Cancelled',
    [MembershipStatusCode.NONR]: 'Non-renewed',
    [MembershipStatusCode.IMPR]: 'Impaired',
    [MembershipStatusCode.FUTR]: 'Future',
    [MembershipStatusCode.VALD]: 'Valid',
    [MembershipStatusCode.EXPD]: 'Expired',
  };
  
  export enum MembershipRoleCode {
    PR = 'PR',
    AD = 'AD',
    DE = 'DE',
    AS = 'AS',
  }
  
  export const MembershipRole = {
    [MembershipRoleCode.PR]: 'Primary',
    [MembershipRoleCode.AD]: 'Adult Associate',
    [MembershipRoleCode.DE]: 'Dependent',
    [MembershipRoleCode.AS]: 'Associate',
  };
  
  export enum OmsCode {
      REG = 'REG',
      ACT = 'ACT',
      NVR = 'NVR',
      ENR = 'ENR',
      CAN = 'CAN'
  }
  
  export const OmsStatusCode = {
      [OmsCode.REG]: 'Registered',
      [OmsCode.ACT]: 'Activated',
      [OmsCode.NVR]: 'Never Registered',
      [OmsCode.ENR]: 'Enrolled',
      [OmsCode.CAN]: 'Cancelled',
  }
  
  export enum MembershipBillPlanCode {
    AC = 'AC',
    AD = 'AD',
    AH = 'AH',
    AM = 'AM',
    AX = 'AX',
    BA = 'BA',
    MP = 'MP',
  }
  
  export const MembershipBillPlan = {
    [MembershipBillPlanCode.AC]: 'Automatic Renewal with CC',
    [MembershipBillPlanCode.AD]: 'Regular Recurring Gift',
    [MembershipBillPlanCode.AH]: 'Automatic Renewal with ACH Account',
    [MembershipBillPlanCode.AM]: 'Regular',
    [MembershipBillPlanCode.AX]: 'Holiday Recurring Gift',
    [MembershipBillPlanCode.BA]: 'Company/Corp. Billed',
    [MembershipBillPlanCode.MP]: 'Monthly Dues with CC',
  };
  
  export interface IPendingBenefit {
    product: string;
    effectiveDate: string;
  }